var map = {
	"./alphabank.ico": 134,
	"./arko.ico": 135,
	"./brazapay.ico": 136,
	"./cashfast.ico": 137,
	"./hubnai.ico": 138,
	"./hypepay.ico": 139,
	"./i3pay.ico": 140,
	"./invpagamentos.ico": 141,
	"./maybank.ico": 142,
	"./mecanizou.ico": 143,
	"./mevpay.ico": 144,
	"./neverra.ico": 145,
	"./sowpay.ico": 146,
	"./ultrapayments.ico": 147
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 133;